export const clearErrors = () => ({
  errors: {},
  type: 'CLEAR_ERRORS',
})

export const setErrors = (errors) => ({
  errors,
  type: 'SET_ERRORS',
})
